import { render } from "./mastros.vue?vue&type=template&id=888a7b82&scoped=true"
import script from "./mastros.vue?vue&type=script&lang=js"
export * from "./mastros.vue?vue&type=script&lang=js"

import "./mastros.vue?vue&type=style&index=0&id=888a7b82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-888a7b82"]])

export default __exports__